module.exports = {"130636100":"蒲阳镇","130636101":"高于铺镇","130636102":"腰山镇","130636103":"蒲上镇","130636104":"神南镇","130636201":"白云乡","130636202":"河口乡","130636203":"安阳乡","130636204":"台鱼乡","130636205":"大悲乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130636.json
// module id = 154
// module chunks = 0